// Copied from @confluence/experiment-personalized-templates-v2/src/mappings/templateToImgMappings.ts
// to avoid circular dependency with @confluence/experiment-cfind-5291-template-touchpoint
import { WHITEBOARD_TEMPLATE_IDS } from './whiteboardMappings.ts';
import { BLUEPRINT_NAMES } from './blueprintNameMapping.ts';

export const imgSrcBase = `https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/taxonomy/`;

export const defaultImgSrc =
	'https://dam-cdn.atl.orangelogic.com/AssetLink/24jio0s0f10wt00f100x8ka51g80147d.png';

export const defaultDarkImgSrc =
	'https://dam-cdn.atl.orangelogic.com/AssetLink/ka6xb0k673ogce3fr8663jhc11v815cv.svg';

export const WHITEBOARD_TEMPLATE_TO_IMG_MAPPING: Record<WHITEBOARD_TEMPLATE_IDS, string> = {
	[WHITEBOARD_TEMPLATE_IDS.ACTION_PLAN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/v775766xlw833sa16cqlc03tuw1tflc2.svg',
	[WHITEBOARD_TEMPLATE_IDS.ANNUAL_CALENDAR]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/gt8mxd565jnlxpcla58q6fik18u0o5b2.png',
	[WHITEBOARD_TEMPLATE_IDS.BRAINWRITING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/286roqo0x24518bmu83f668tu5dvgms2.png',
	[WHITEBOARD_TEMPLATE_IDS.CONCEPT_MAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/em34t20hd3k5d3y5lou7ac3pt8nwh53w.svg',
	[WHITEBOARD_TEMPLATE_IDS.CRAZY_8S_BRAINSTORMING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/hhhhhjyr0k0tkwqj64550117ytp50i1e.png',
	[WHITEBOARD_TEMPLATE_IDS.DISRUPTIVE_BRAINSTORM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/v4n83g7myc10be1f0uahh76jls455i8u.png',
	[WHITEBOARD_TEMPLATE_IDS.EXECUTIVE_SUMMARY]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/54i677d21ed42r1d7ws1bfd37nwf36s8.svg',
	[WHITEBOARD_TEMPLATE_IDS.FISHBONE_DIAGRAM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/16065dh57ba4b022x51r0tkqbd28dl87.svg',
	[WHITEBOARD_TEMPLATE_IDS.FLOWCHART]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/26814iat2a7ndfjrs0uq5i2g0x72867y.png',
	[WHITEBOARD_TEMPLATE_IDS.FOCUS_AREA_DIAGRAM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/o7sw2x42srn06s00a0esiq788283341p.svg',
	[WHITEBOARD_TEMPLATE_IDS.FOURLS_RETRO]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/hu6yl738y22o50t0pr2vo4o05wan62n1.png',
	[WHITEBOARD_TEMPLATE_IDS.GAP_ANALYSIS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/0dn87kk6o66hvf420nfqjg45615k4m73.png',
	[WHITEBOARD_TEMPLATE_IDS.INCIDENT_POSTMORTEM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/3d765023oqb4btu13pj7wdw5343wx6vv.png',
	[WHITEBOARD_TEMPLATE_IDS.ICEBREAKERS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/8i66o10j7qu27884l2c3si1xh0335w14.png',
	[WHITEBOARD_TEMPLATE_IDS.NETWORK_OF_TEAMS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/l5343a3n0485ax1nh434373xq8g5l6s7.png',
	[WHITEBOARD_TEMPLATE_IDS.ORG_CHART]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/0e1c2vi1r8376b5t834kd607uqt0ymyp.png',
	[WHITEBOARD_TEMPLATE_IDS.PRIORITIZATION_MATRIX]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/cm3igo2rky6iip0h1t3wy67pek85mla5.png',
	[WHITEBOARD_TEMPLATE_IDS.PRODUCT_VISION_BOARD]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/6a51tvn7g1o3tl3vqvg0nsb14p60w77d.png',
	[WHITEBOARD_TEMPLATE_IDS.ROOT_CAUSE_TEMPLATE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/76p747np1oon57pu221347ohfjvnm180.svg',
	[WHITEBOARD_TEMPLATE_IDS.SERVICE_BLUEPRINT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/617mv306vsf7w6sp43b6w6pas8xt4djd.png',
	[WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/5ks001pi5jng10bnv131n7nu0k40l3xo.svg',
	[WHITEBOARD_TEMPLATE_IDS.STAKEHOLDER_MAPPING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/370bf03j886cokvq31658l4l3w66wv6p.svg',
	[WHITEBOARD_TEMPLATE_IDS.SWIMLANES_PROCESS_MAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/30u4108cdrbb83082p01f6810dtf1of4.png',
	[WHITEBOARD_TEMPLATE_IDS.SWOT_ANALYSIS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/w814j2a58v56xuxoi444u5biqctwlhub.svg',
	[WHITEBOARD_TEMPLATE_IDS.TEAM_CHARTER_TEMPLATE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/kl7cn5h28ysoc3ti2gwyx6025v2b2nac.png',
	[WHITEBOARD_TEMPLATE_IDS.TEAM_HEALTH_MONITOR]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/1e56m4o21348hk5j226181v4elqwi0w1.svg',
	[WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/t520b6d576imhfl70je80l8x8d77bduo.png',
	[WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/m3hvi182obpt68vrr0x32k7kpcn7j844.png',
	[WHITEBOARD_TEMPLATE_IDS.WORKFLOW_TEMPLATE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/b4gx5wo7fsn6we642b242q7188gsq386.png',
	[WHITEBOARD_TEMPLATE_IDS.PRODUCT_ROADMAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/w2w6e854gvt71756v2q53318t6t3vei3.png',
	[WHITEBOARD_TEMPLATE_IDS.ELEVATOR_PITCH]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/5u8b4i1104l3d762gb8023m1itq7l34x.svg',
} as const;

export const WHITEBOARD_TEMPLATE_TO_DARK_IMG_MAPPING: Record<WHITEBOARD_TEMPLATE_IDS, string> = {
	[WHITEBOARD_TEMPLATE_IDS.ACTION_PLAN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/8y8sc20314pf86r8887x1rh3j57t7v0m.svg',
	[WHITEBOARD_TEMPLATE_IDS.ANNUAL_CALENDAR]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/a6x7e6e50ynr0m1117k686cu15f702xn.svg',
	[WHITEBOARD_TEMPLATE_IDS.BRAINWRITING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/g0o1ks846i88hr5a3b64682r5om4202q.svg',
	[WHITEBOARD_TEMPLATE_IDS.CONCEPT_MAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/4ywpy0ek1o1o4rwao564k64v15ex4618.svg',
	[WHITEBOARD_TEMPLATE_IDS.CRAZY_8S_BRAINSTORMING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/31t5j2o00j2s7t5ew0n6pr4kp4phvt04.svg',
	[WHITEBOARD_TEMPLATE_IDS.DISRUPTIVE_BRAINSTORM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/o360h3o63u55epg1ai452ds5mms5i8x5.svg',
	[WHITEBOARD_TEMPLATE_IDS.EXECUTIVE_SUMMARY]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ul7j8s4v6o2336il6a781m566t0rr6sc.svg',
	[WHITEBOARD_TEMPLATE_IDS.FISHBONE_DIAGRAM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/715fur87612t53h5m4bwg11k5j5w3771.svg',
	[WHITEBOARD_TEMPLATE_IDS.FLOWCHART]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/t3mfg1hxryf30du04apjsn3rf6i53ujn.svg',
	[WHITEBOARD_TEMPLATE_IDS.FOCUS_AREA_DIAGRAM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/nc8ogfbk5y7nugu56gy14cbk8564k4m1.svg',
	[WHITEBOARD_TEMPLATE_IDS.FOURLS_RETRO]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/650c73qh4cx735v8v40530xf4l5gr263.svg',
	[WHITEBOARD_TEMPLATE_IDS.GAP_ANALYSIS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/7a32ce1yafkbwyroef6b5ty6y7684560.svg',
	[WHITEBOARD_TEMPLATE_IDS.INCIDENT_POSTMORTEM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/mg40lr1ans63vk7t0rqwq53hx3mv3x0a.svg',
	[WHITEBOARD_TEMPLATE_IDS.ICEBREAKERS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/8543ywanoenx7v0w2fo57874w081rs50.svg',
	[WHITEBOARD_TEMPLATE_IDS.NETWORK_OF_TEAMS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/dp08ln0x64w03f6855vt5k25xttu8y1y.svg',
	[WHITEBOARD_TEMPLATE_IDS.ORG_CHART]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/kpq78wcv70g231k70x6083uw1oj35x15.svg',
	[WHITEBOARD_TEMPLATE_IDS.PRIORITIZATION_MATRIX]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/qi6q25nj7657c511n5t06gu6a6cf7nk4.svg',
	[WHITEBOARD_TEMPLATE_IDS.PRODUCT_ROADMAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/dd47fnm3l1ngnqcie3ad4oj747251s37.svg',
	[WHITEBOARD_TEMPLATE_IDS.PRODUCT_VISION_BOARD]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/eu16r33866w646j52x351lpsceof0057.svg',
	[WHITEBOARD_TEMPLATE_IDS.ROOT_CAUSE_TEMPLATE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/g1um66bc1q5ia7x04gsdl0rgx87j6jvm.svg',
	[WHITEBOARD_TEMPLATE_IDS.SERVICE_BLUEPRINT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/fe1f2sv15s3q667sqp4w2l3271qp431y.svg',
	[WHITEBOARD_TEMPLATE_IDS.SIMPLE_RETROSPECTIVE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/yxsr7cv8cc4ox20f6am0788u13tx8731.svg',
	[WHITEBOARD_TEMPLATE_IDS.STAKEHOLDER_MAPPING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/dptnm3xu130487m1a3eo1y780g274c38.svg',
	[WHITEBOARD_TEMPLATE_IDS.SWIMLANES_PROCESS_MAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/3ao2nw5gfffwms6j4w0fd07126007215.svg',
	[WHITEBOARD_TEMPLATE_IDS.SWOT_ANALYSIS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/i88nc0mpr1j8m2v045a7s6ik0x827ero.svg',
	[WHITEBOARD_TEMPLATE_IDS.TEAM_CHARTER_TEMPLATE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/i622u0u2h5d2o0b23abf1qx57h36p8a8.svg',
	[WHITEBOARD_TEMPLATE_IDS.TEAM_HEALTH_MONITOR]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/x1687g5ye71fs1qfym3a653nls22g460.svg',
	[WHITEBOARD_TEMPLATE_IDS.TIMELINE_WORKFLOW]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/17uws3bph888pu42v71k12nbq27i4k5a.svg',
	[WHITEBOARD_TEMPLATE_IDS.USER_STORY_MAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/1l6gk820v5e7h17h0y4b27sb4l5whvy3.svg',
	[WHITEBOARD_TEMPLATE_IDS.WORKFLOW_TEMPLATE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/1hquucr1ec0b4l1ht06l68sh80r0rs4q.svg',
	[WHITEBOARD_TEMPLATE_IDS.ELEVATOR_PITCH]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ltv22274128075mvb5h842f082vd35ik.svg',
} as const;

export const BLUEPRINT_NAME_TO_URL_SLUGS_MAPPING: Partial<Record<BLUEPRINT_NAMES, string>> = {
	[BLUEPRINT_NAMES.NINETY_DAY_PLAN]: '90-day-plan',
	[BLUEPRINT_NAMES.ALL_HANDS_MEETING]: 'all-hands-meeting',
	[BLUEPRINT_NAMES.ANNUAL_PLAN_ONE_PAGER]: 'annual-plan-one-pager',
	[BLUEPRINT_NAMES.EXECUTIVE_BUSINESS_REVIEW]: 'executive-business-review',
	[BLUEPRINT_NAMES.BUSINESS_STATUS_UPDATE]: 'business-status-update',
	[BLUEPRINT_NAMES.BUSINESS_PLAN_ONE_PAGER]: 'business-plan-one-pager',
	[BLUEPRINT_NAMES.CAREER_DEVELOPMENT_PLAN]: 'career-development-plan',
	[BLUEPRINT_NAMES.COMPETITIVE_ANALYSIS]: 'competitive-analysis',
	[BLUEPRINT_NAMES.CONTENT_DESIGN_GLOSSARY]: 'content-design-glossary',
	[BLUEPRINT_NAMES.CONTENT_STRATEGY]: 'content-strategy',
	[BLUEPRINT_NAMES.CUSTOMER_IMPACT_ASSESSMENT]: 'customer-impact-assessment',
	[BLUEPRINT_NAMES.CUSTOMER_INTERVIEW_REPORT]: 'customer-interview-report',
	[BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION]: 'decision',
	[BLUEPRINT_NAMES.DESIGN_DECISION]: 'design-decision',
	[BLUEPRINT_NAMES.DESIGN_REVIEW]: 'design-review',
	[BLUEPRINT_NAMES.DESIGN_SPRINT]: 'design-sprint',
	[BLUEPRINT_NAMES.DESIGN_SYSTEMS]: 'design-system',
	[BLUEPRINT_NAMES.DEVOPS_RUNBOOK]: 'devops-runbook',
	[BLUEPRINT_NAMES.EMPLOYEE_HANDBOOK]: 'employee-handbook',
	[BLUEPRINT_NAMES.HR_KNOWLEDGE_BASE_MANAGEMENT]: 'hr-knowledge-base',
	[BLUEPRINT_NAMES.HOW_TO_ARTICLE]: 'how-to-article',
	[BLUEPRINT_NAMES.ITSM_KNOWN_ERRORS]: 'itsm-known-errors',
	[BLUEPRINT_NAMES.ITSM_CHANGE_MANAGEMENT]: 'itsm-change-management',
	[BLUEPRINT_NAMES.ITSM_POST_INCIDENT_REVIEWS]: 'itsm-post-incident-review',
	[BLUEPRINT_NAMES.ITSM_RUNBOOK]: 'itsm-runbook',
	[BLUEPRINT_NAMES.INCIDENT_COMMUNICATION]: 'incident-communication',
	[BLUEPRINT_NAMES.INCIDENT_POSTMORTEM]: 'incident-postmortem',
	[BLUEPRINT_NAMES.JOB_DESCRIPTION]: 'job-description',
	[BLUEPRINT_NAMES.LENNYS_PERFORMANCE_REVIEW]: 'lennys-performance-review',
	[BLUEPRINT_NAMES.LENNYS_PRODUCT_REQUIREMENTS]: 'lennys-product-requirements',
	[BLUEPRINT_NAMES.MARKETING_PLAN]: 'marketing-plan',
	[BLUEPRINT_NAMES.MEETING_NOTES]: 'meeting-notes',
	[BLUEPRINT_NAMES.MESSAGE_HOUSE]: 'message-house',
	[BLUEPRINT_NAMES.OKRS]: 'okrs',
	[BLUEPRINT_NAMES.PERSONA]: 'persona',
	[BLUEPRINT_NAMES.PRESENTER_MODE]: 'presenter-mode',
	[BLUEPRINT_NAMES.PRODUCT_REQUIREMENTS]: 'product-requirements',
	[BLUEPRINT_NAMES.PRODUCT_ROADMAP]: 'product-roadmap',
	[BLUEPRINT_NAMES.PROJECT_KICKOFF]: 'project-kickoff',
	[BLUEPRINT_NAMES.PROJECT_PLAN]: 'project-plan',
	[BLUEPRINT_NAMES.PROJECT_STATUS]: 'project-status',
	[BLUEPRINT_NAMES.PROJECT_TIMELINE_TEMPLATE]: 'project-timeline',
	[BLUEPRINT_NAMES.QTC_ACQUISITION]: 'qtc-acquisition',
	[BLUEPRINT_NAMES.REMOTE_TEAM_MEETING]: 'remote-team-meeting',
	[BLUEPRINT_NAMES.RISK_ASSESSMENT_MATRIX]: 'risk-assessment',
	[BLUEPRINT_NAMES.ROLES_AND_RESPONSIBILITIES]: 'roles-and-responsibilities',
	[BLUEPRINT_NAMES.SMART_GOALS]: 'smart-goals',
	[BLUEPRINT_NAMES.SWOT_ANALYSIS]: 'swot-analysis',
	[BLUEPRINT_NAMES.SALES_PORTAL]: 'sales-portal',
	[BLUEPRINT_NAMES.SALES_ACCOUNT_PLANNING]: 'sales-account-planning',
	[BLUEPRINT_NAMES.SOFTWARE_ARCHITECTURE_REVIEW]: 'software-architecture-review',
	[BLUEPRINT_NAMES.SPRINT_PLANNING_MEETING]: 'sprint-planning-meeting',
	[BLUEPRINT_NAMES.STAKEHOLDER_COMMUNICATIONS]: 'stakeholder-communications',
	[BLUEPRINT_NAMES.STANDARD_OPERATING_PROCEDURE_TEMPLATE]: 'sop',
	[BLUEPRINT_NAMES.STRATEGIC_PLAN]: 'strategic-plan',
	[BLUEPRINT_NAMES.TEAM_HOMEPAGE]: 'team-homepage',
	[BLUEPRINT_NAMES.TEAM_POSTER]: 'team-poster',
	[BLUEPRINT_NAMES.TO_DO_LIST]: 'to-do-list',
	[BLUEPRINT_NAMES.TROUBLESHOOTING_ARTICLE]: 'troubleshooting-article',
	[BLUEPRINT_NAMES.VENDOR_AGREEMENT]: 'vendor-agreement',
	[BLUEPRINT_NAMES.VIRTUAL_EVENT]: 'virtual-event',
	[BLUEPRINT_NAMES.VISION_TO_VALUES]: 'vision-to-values',
	[BLUEPRINT_NAMES.END_OF_WEEK_STATUS_REPORT]: 'end-of-week-status-report',
	[BLUEPRINT_NAMES.WEEKLY_MEETING_NOTES]: 'weekly-meeting-notes',
	[BLUEPRINT_NAMES.WORK_TRIP_PLANNER]: 'work-trip-planner',
	[BLUEPRINT_NAMES.WORKSHOP_PLANNER]: 'workshop-planner',
	[BLUEPRINT_NAMES.WRITING_GUIDELINES]: 'writing-guidelines',
	[BLUEPRINT_NAMES.QUARTERLY_CHECK_IN]: 'quarterly-check-in',
	[BLUEPRINT_NAMES.AWS_ARCHITECTURE_DIAGRAM]: 'aws-architecture-diagram',
	[BLUEPRINT_NAMES.MARKETING_BLOG_POST]: 'marketing-blog-post',
	[BLUEPRINT_NAMES.MARKETING_CAMPAIGN]: 'marketing-campaign',
	[BLUEPRINT_NAMES.HIRING_PROCESS]: 'hiring-process',
	[BLUEPRINT_NAMES.MUTUAL_ACTION_PLAN]: 'mutual-action-plan',
	[BLUEPRINT_NAMES.ITSM_WEEKLY_MAJOR_INCIDENT_REPORT]: 'itsm-weekly-major-incident-report',
	[BLUEPRINT_NAMES.DISRUPTIVE_BRAINSTORMING]: 'disruptive-brainstorming',
} as const;

const blueprintsWithoutImages: Set<BLUEPRINT_NAMES> = new Set([
	BLUEPRINT_NAMES.STANDARD_OPERATING_PROCEDURE_TEMPLATE,
	BLUEPRINT_NAMES.PROJECT_TIMELINE_TEMPLATE,
	BLUEPRINT_NAMES.SOFTWARE_ARCHITECTURE_REVIEW,
	BLUEPRINT_NAMES.LENNYS_PERFORMANCE_REVIEW,
	BLUEPRINT_NAMES.LENNYS_PRODUCT_REQUIREMENTS,
	BLUEPRINT_NAMES.NON_DISCLOSURE_AGREEMENT,
]);

export const BLUEPRINT_NAME_TO_IMG_MAPPING: Partial<Record<BLUEPRINT_NAMES, string>> = Object.keys(
	BLUEPRINT_NAME_TO_URL_SLUGS_MAPPING,
).reduce(
	(mappings, key) => {
		mappings[key as BLUEPRINT_NAMES] = blueprintsWithoutImages.has(key as BLUEPRINT_NAMES)
			? defaultImgSrc
			: `${imgSrcBase}${BLUEPRINT_NAME_TO_URL_SLUGS_MAPPING[key as BLUEPRINT_NAMES]}.svg`;
		return mappings;
	},
	{} as Partial<Record<BLUEPRINT_NAMES, string>>,
);

export const BLUEPRINT_IMG_MAP_DARK: Partial<Record<BLUEPRINT_NAMES, string>> = {
	[BLUEPRINT_NAMES.DESIGN_REVIEW]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/h4k3b710fj7203m0hj43j3cc425cuy76.svg',
	[BLUEPRINT_NAMES.DESIGN_SPRINT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/olpn6123xee0naxqm57sf3bpnr3mvglw.svg',
	[BLUEPRINT_NAMES.DESIGN_DECISION]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/1x53580r2xjt08816apkqrwq6g7ga107.svg',
	[BLUEPRINT_NAMES.DACI_DECISION_DOCUMENTATION]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/juc54l2t2c16lx8k1g3e3q1076ckmfng.svg',
	[BLUEPRINT_NAMES.CUSTOMER_INTERVIEW_REPORT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/0e473ir7jdwlcoyls06uc04iim077741.svg',
	[BLUEPRINT_NAMES.CONTENT_STRATEGY]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/m06ipqhy7no6d5ab6qrd7kqfhlggy2ni.svg',
	[BLUEPRINT_NAMES.CONTENT_DESIGN_GLOSSARY]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ayg5h2aq885e62ysr47865rg461uw2we.svg',
	[BLUEPRINT_NAMES.CAREER_DEVELOPMENT_PLAN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ms2f3506w5a41lv6jk38ucy8882yky4e.svg',
	[BLUEPRINT_NAMES.COMPETITIVE_ANALYSIS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/1s4ovxh8tpsk74g33lmd4ujw0np3o731.svg',
	[BLUEPRINT_NAMES.BUSINESS_STATUS_UPDATE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/s8644uajks6cw0fj2o0q1e7tf645pjdq.svg',
	[BLUEPRINT_NAMES.BUSINESS_PLAN_ONE_PAGER]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/q7243b5o3jvm6vo3504p7rc8o667pmy6.svg',
	[BLUEPRINT_NAMES.ITSM_RUNBOOK]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/g5y6q6oqf15txlpv1q2m53648sh1888w.svg',
	[BLUEPRINT_NAMES.ITSM_KNOWN_ERRORS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/843prjia43re78n53vh4f1nkvm5lbb43.svg',
	[BLUEPRINT_NAMES.HR_KNOWLEDGE_BASE_MANAGEMENT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/waj1m80wt58g346m3bx1l82cq5fn785e.svg',
	[BLUEPRINT_NAMES.EXECUTIVE_BUSINESS_REVIEW]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/2sb43g4320785m6k44k8djm3d7487s01.svg',
	[BLUEPRINT_NAMES.HOW_TO_ARTICLE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/871dux30tosjc8ipe18fr346rmqe4juf.svg',
	[BLUEPRINT_NAMES.ANNUAL_PLAN_ONE_PAGER]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/2atvs27hd5w232sg773008l3q2fssr4o.svg',
	[BLUEPRINT_NAMES.NINETY_DAY_PLAN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/eub8wfax8n446u54req1vvq0i5y4ai51.svg',
	[BLUEPRINT_NAMES.ALL_HANDS_MEETING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/l8c1g33u3a37qc73v4v0ple4bt7582u8.svg',
	[BLUEPRINT_NAMES.PROJECT_KICKOFF]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/q23316jb58686pa5na5l23hp4tmlym5q.svg',
	[BLUEPRINT_NAMES.PERSONA]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/3288qdj186qk418dt7p3fp5m1ngy1204.svg',
	[BLUEPRINT_NAMES.DESIGN_SYSTEMS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/3r6x6daq4gj0a8w55gv4l0mi0l2jq676.svg',
	[BLUEPRINT_NAMES.DEVOPS_RUNBOOK]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/55p8fe88y7345bq5o8ld1wo4b3s6x7fk.svg',
	[BLUEPRINT_NAMES.END_OF_WEEK_STATUS_REPORT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/322w834s7iv5cv55sawmnvnj214165l8.svg',
	[BLUEPRINT_NAMES.EMPLOYEE_HANDBOOK]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/d154e06qu2wc6f4rvf24qn5q352ni5y5.svg',
	[BLUEPRINT_NAMES.CUSTOMER_IMPACT_ASSESSMENT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/x80i888ygwk623tn3b1i1ol70p7v7sa1.svg',
	[BLUEPRINT_NAMES.ITSM_POST_INCIDENT_REVIEWS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/8wx1f2120m7qo2osbgh3m26o0h13b460.svg',
	[BLUEPRINT_NAMES.INCIDENT_POSTMORTEM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/3p11p1kfnqf1xtj2i6282pup7500v5v7.svg',
	[BLUEPRINT_NAMES.ITSM_CHANGE_MANAGEMENT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/07h8i0ldabdfh18e0f3406xfw32fk787.svg',
	[BLUEPRINT_NAMES.INCIDENT_COMMUNICATION]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/un7420lmym06873pxv6i7us28442i30e.svg',
	[BLUEPRINT_NAMES.JOB_DESCRIPTION]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/3lwqq2rfxv426g7op1js2b8470g26sfu.svg',
	[BLUEPRINT_NAMES.PROJECT_PLAN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ed8e6w12k8ar4d1523lr3rpx3ys68dhh.svg',
	[BLUEPRINT_NAMES.PRODUCT_REQUIREMENTS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/626r1r03m1i01w37o72r6y7n57t0plmq.svg',
	[BLUEPRINT_NAMES.PRESENTER_MODE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/x763b1j8e1y71f0lh286048tn6q30035.svg',
	[BLUEPRINT_NAMES.MEETING_NOTES]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/36p554e65x6ub45035dacj50l08mjpo0.svg',
	[BLUEPRINT_NAMES.ROLES_AND_RESPONSIBILITIES]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/p204067765c1yfd83im6hpt7cv4mfkc7.svg',
	[BLUEPRINT_NAMES.SALES_ACCOUNT_PLANNING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/3sj6n68sjtf332lau0l627qr3ot3qe2v.svg',
	[BLUEPRINT_NAMES.RISK_ASSESSMENT_MATRIX]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/x2n21bdg03i16s3t16tprkv6537446s5.svg',
	[BLUEPRINT_NAMES.QUARTERLY_CHECK_IN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/26a3wch8758m13o012m762xxv25ch8vg.svg',
	[BLUEPRINT_NAMES.SMART_GOALS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/2bf67v33y7f2ln226xipfru2n7kns60b.svg',
	[BLUEPRINT_NAMES.VIRTUAL_EVENT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/c0i6b28xct78230ggb358m1047081ww5.svg',
	[BLUEPRINT_NAMES.TEAM_POSTER]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/k4r783xvvwvviw60i728w66g3nl8a1sn.svg',
	[BLUEPRINT_NAMES.TROUBLESHOOTING_ARTICLE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ok5ycecnech333n2m582ix021r2jy65k.svg',
	[BLUEPRINT_NAMES.TEAM_HOMEPAGE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/0rnr6dq077l1x5wx53q036arpk780f2p.svg',
	[BLUEPRINT_NAMES.SWOT_ANALYSIS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/wmlg4wd6587651183as8031t301d4o85.svg',
	[BLUEPRINT_NAMES.TO_DO_LIST]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/1asf3cijux7ga204cbc7qg6ra367nhc7.svg',
	[BLUEPRINT_NAMES.WORK_TRIP_PLANNER]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ogmwu64w8pwoxp2ho80nd87kp2x2pa3g.svg',
	[BLUEPRINT_NAMES.WRITING_GUIDELINES]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/64524bi14mrls3rem07y1p25hkumv16u.svg',
	[BLUEPRINT_NAMES.WORKSHOP_PLANNER]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/u0nub00c433fl778atn5yhgjoh782l13.svg',
	[BLUEPRINT_NAMES.WEEKLY_MEETING_NOTES]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/y0i7w3ks85280ehvpr28lpu5yg3ja0a7.svg',
	[BLUEPRINT_NAMES.VISION_TO_VALUES]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/7mx000d02pi8r2ueg3rw7v01lgbj55dp.svg',
	[BLUEPRINT_NAMES.PRODUCT_ROADMAP]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/0wtr2h661307rsnsoolf1k4502semf22.svg',
	[BLUEPRINT_NAMES.OKRS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/363722lk1ks8ut57cxor25f1d0864170.svg',
	[BLUEPRINT_NAMES.MARKETING_PLAN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/tt73e3c4016001x617mxxitl5g3u1n65.svg',
	[BLUEPRINT_NAMES.MESSAGE_HOUSE]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/0b2egux177m04b0dxo628v4m3s103460.svg',
	[BLUEPRINT_NAMES.SALES_PORTAL]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/j233apow7he8t03o2dn0o51g52mnw15j.svg',
	[BLUEPRINT_NAMES.REMOTE_TEAM_MEETING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/7cknim011u00041rmw2yw1vr3w65xan1.svg',
	[BLUEPRINT_NAMES.QTC_ACQUISITION]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ek48h0gx82ks3j46480m6c6cu2h1e7wq.svg',
	[BLUEPRINT_NAMES.PROJECT_STATUS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/vwpc40ldd857guo662l34831851l8h1x.svg',
	[BLUEPRINT_NAMES.VENDOR_AGREEMENT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/vkq707lue205jypgy6kiy30u650u566x.svg',
	[BLUEPRINT_NAMES.STAKEHOLDER_COMMUNICATIONS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/wldn3c51e68086nl43q8wpk1x8yrcg17.svg',
	[BLUEPRINT_NAMES.STRATEGIC_PLAN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/d25x120oi2118101kxfmt10aqm2g8cvv.svg',
	[BLUEPRINT_NAMES.SPRINT_PLANNING_MEETING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/8j1bvq02m82l623fy575sd7of2djd7my.svg',
	[BLUEPRINT_NAMES.AWS_ARCHITECTURE_DIAGRAM]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/3575i1013te6m8sp1xr08f54e8053egq.svg',
	[BLUEPRINT_NAMES.MARKETING_BLOG_POST]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/xfw4001fj343b5k7fteg177lb3175blr.svg',
	[BLUEPRINT_NAMES.MARKETING_CAMPAIGN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/70u14cws7507hm18ak4lp7eq5k0a8582.svg',
	[BLUEPRINT_NAMES.HIRING_PROCESS]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/dc3418xr3v7522y6dv4gg636nmvf8y41.svg',
	[BLUEPRINT_NAMES.MUTUAL_ACTION_PLAN]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/gm7gxjca3f0i7eon74md67f57c0r3qq1.svg',
	[BLUEPRINT_NAMES.ITSM_WEEKLY_MAJOR_INCIDENT_REPORT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/57ib28g38e3c0h5tj3ak5fxn3g2ppq7o.svg',
	[BLUEPRINT_NAMES.DISRUPTIVE_BRAINSTORMING]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/38dc3au247c7a030ya5c7f3ajp7131lq.svg',
	[BLUEPRINT_NAMES.NON_DISCLOSURE_AGREEMENT]:
		'https://dam-cdn.atl.orangelogic.com/AssetLink/ed8e6w12k8ar4d1523lr3rpx3ys68dhh.svg',
};
